var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentsBorded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M34.9951 0C43.2793 5.01776e-05 49.9951 6.71576 49.9951 15V35C49.9951 43.2842 43.2793 49.9999 34.9951 50H15C6.71573 50 3.22153e-07 43.2843 0 35V15C3.22154e-07 6.71573 6.71573 0 15 0H34.9951Z",
    fill: "#D28715"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    d: "M32.4942 19.667C34.5653 19.667 36.2442 21.4579 36.2442 23.667C36.244 25.8759 34.5651 27.667 32.4942 27.667C30.4235 27.6668 28.7444 25.8758 28.7442 23.667C28.7442 21.458 30.4233 19.6672 32.4942 19.667ZM21.2481 13C24.0094 13 26.2479 15.3877 26.2481 18.333C26.2481 21.2785 24.0095 23.667 21.2481 23.667C18.4867 23.667 16.2481 21.2785 16.2481 18.333C16.2483 15.3876 18.4868 13 21.2481 13Z",
    fill: "#D28715"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2235 26.3335C27.2076 26.3335 32.1246 29.3909 32.491 35.9331C32.5056 36.1937 32.4905 37.0005 31.5516 37.0005H10.9051C10.5917 37.0005 9.96954 36.2788 9.99593 35.9321C10.4805 29.5687 15.3223 26.3335 21.2235 26.3335ZM31.9959 29.0024C36.2538 29.0519 39.7303 31.3466 39.992 36.1997C40.0026 36.3952 39.9923 37.0004 39.3143 37.0005H34.494C34.494 33.9996 33.5643 31.2306 31.9959 29.0024Z",
    fill: "#D28715"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsBorded);
export default __webpack_public_path__ + "static/media/StudentsBorded.2534e810280e280d808aece514b4c49a.svg";
export { ForwardRef as ReactComponent };